import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { CREATE_EDU } from "actions/ActionTypes";
import { postApi } from "actions/SendActions";
import EDUAdminForm from "components/edu/EDUAdminForm";

import "css/admin/smartlist.scss";

export function EDUAdminCreateUI({ onSubmit, token, t }) {
  const { projectSlug } = useParams();

  const item = {
    edu_name: t("newEdu"),
    type: "liblynx",
    avatar: null,
    enabled: false,
    user_edu: {
      max_session: 0,
      nbr_users: 0,
      authentication_name: "",
    },
    offer_uuid: null,
    offer_plan_uuid: null,
  };

  const onCreate = (item) => {
    item.edu_name = item.label;
    delete item.label;
    if (item.avatar) delete item.avatar_url;

    const newUser = {
      user: item,
      notifications: {
        registration: false,
        create_password: false,
      },
    };

    onSubmit(newUser, token, projectSlug, t);
  };

  return <EDUAdminForm item={item} onSubmit={onCreate} type="new" />;
}

EDUAdminCreateUI.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { token } = state.loginReducer;

  return {
    token,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onSubmit(data, token, projectSlug, t) {
    dispatch(
      postApi({
        endpoint: "/api/user/v3/admin/users/create/edu",
        type: CREATE_EDU,
        item: "edus",
        headers: [
          {
            key: "xx-ok-project",
            value: projectSlug,
          },
        ],
        token,
        data,
        message: t("editor-notif:saveSuccess"),
        error: t("editor-notif:saveError"),
      }),
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("editor-edu", "editor-errors")(EDUAdminCreateUI));
